import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/management/trash.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2b243356")

_pushScopeId("data-v-2b243356")
const _hoisted_1 = {
  key: 0,
  class: "postAttachment"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.preview && !  _ctx.wantDeleteAttachment)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: "removeButton",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('removeAttachment')))
        }, [
          _hoisted_2
        ]),
        _createVNode("div", {
          class: ["postImage", _ctx.getAdditionalClass],
          style: 'background-image: url(\'' + _ctx.$filters.previewFix(_ctx.preview) + '\');'
        }, null, 6)
      ]))
    : _createCommentVNode("", true)
})